import { render, staticRenderFns } from "./internet-error.vue?vue&type=template&id=2de54db3&scoped=true"
import script from "./internet-error.vue?vue&type=script&lang=ts"
export * from "./internet-error.vue?vue&type=script&lang=ts"
import style0 from "./internet-error.vue?vue&type=style&index=0&id=2de54db3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de54db3",
  null
  
)

export default component.exports